import ViewSGBSApplicationFormFeature from "../../features/ViewSGBSApplicationFormFeature/ViewSGBSApplicationFormFeature";
import "./ViewSGBSApplication.scss"

const ViewSGBSApplicationForm = () => {
  return (
    <div>
      <ViewSGBSApplicationFormFeature />
    </div>
  );
};
export default ViewSGBSApplicationForm;
